<template>
    <div>

        <form @change="getBLname(bundesland)" class="form-inline mb-3">
        <div class="form-row">
            <div class="form-group  mr-2">
                <select  class="custom-select my-1 mr-sm-2" name="bundesland"  v-model="bundesland" id="mylocations-bundesland">
                    <option value="0" disable="true" selected="true">=== Bundesland ===</option>
                    <option v-for="option in bundesland_op" :value="option.BLID" :key="option.BLID">
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="d-none form-row">
            <div class="form-group   mr-2">
                <select  class="custom-select my-1 mr-sm-2" name="bezirke"  id="mylocations-bezirke" v-model="bezirke">
                    <option value="0" disable="true" selected="true">=== Bezirke ===</option>
                    <option v-for="option in bezirke_op[bundesland]" :value="option.BEZIRK" :key="option.IDBEZ">
                        {{ option.BEZIRK }}
                    </option>
                </select>
            </div>
        </div>
            <div class="form-row">
                <div class="form-group   mr-2">
                    <select  class="custom-select my-1 mr-sm-2" name="bezirke"  id="mylocations-bezirke" v-model="bezirke">
                        <option value="0" disable="true" selected="true">=== Bezirke ===</option>
                        <option v-for="option in bezirke_op" :value="option.BEZIRK" :key="option.IDBEZ">
                            {{ option.BEZIRK }}
                        </option>
                    </select>
                </div>
            </div>
        </form>
    </div>
</template>

<script>







    export default {
        //name: "chainselect",  // using EXACTLY this name is essential
        name: "mylocations2AlleBranchenBundesland",


        props: {
            hasbundeslandprobs: {
                type: String,
            },
            hasbezirkprobs: {
                type: String,
            },

            brancheprobs: {
                type: String,
                default: ''
            },
            blidprobs:{
                type: String,
                default: '0'
            },
            bundeslandprobs:{
                type: String,
                default: ''
            }


        },

        data() {
            return {
                bundesland_op: [],
                bezirke_op: {},
                branche: this.brancheprobs,
                success: '',
                bundesland: this.blidprobs,
                bezirke: 0,
                bundeslandName: this.bundeslandprobs

            }

        },


        // props: ['bundesland','bezirke','gemeinde','orte','plz'],
        watch: {},

        methods: {
            loadBundesland() {
                axios.get("/mylocations/vue/bundesland").then(response => this.bundesland_op = response.data);
            },
            loadBezirke() {
                axios.get("/mylocations/vue/bezirke").then(response => this.bezirke_op = response.data);
            },

            loadHasBundesland(){
                this.bundesland_op = JSON.parse(this.hasbundeslandprobs);
            },

            loadHasBezirk(){
                this.bezirke_op = JSON.parse(this.hasbezirkprobs);
            },

            getBLname(id){
                axios.get("/mylocations/vue/getBundeslandName/" + id).then(response => {
                    this.bundeslandName = response.data[0];
                    this.ladeseite();
                }
                );
            },

            ladeseite(){
                if(this.bezirke == 0 ){
                    window.location.href = 'https://'+location.hostname+'/suche/' + this.branche.toLowerCase() +'/' + this.bundeslandName.toLowerCase();
                }
                 window.location.href = 'https://'+location.hostname+'/suche/' + this.branche.toLowerCase() +'/' + this.bundeslandName.toLowerCase() + '/' + this.bezirke.toLowerCase();
            },


            /*
            getBLname: _.debounce(function(id){
                axios.get("/mylocations/vue/getBundeslandName/" + id).then(response => this.bundeslandName = response.data[0]);
                console.log('bundeslandnamein getBlName = ',  this.bundeslandName);
                return this.bundeslandName;
                        }, 500),
            */



        },
        created() {
            //this.loadBundesland();
            this.loadHasBundesland();
            //this.loadBezirke();
            this.loadHasBezirk();
            console.log('bin in MyLocations2AlleBranchen')


        }
    }


</script>

<style scoped>

</style>
